import { TimeSheetEntry } from "../store/Data";

export const TimeSheets_Customer_NotInvoiced = async (token: string, customerId: string): Promise<TimeSheetEntry[] | undefined | null> => {
    if (!customerId || !token) return null;

    return fetch(`api/TimeSheets/` + customerId + "/UnInvoicedForCustomer", {
        method: "get",
        headers: {
            "Content-Type": "application/json",
            authorization: "bearer " + token,
        },
        mode: "cors",
        cache: "default",
    })
        .then(response => {
            if (response.status === 403) {
                return null;
            }
            else if (response.status === 404 || response.status === 204) {
                return undefined;
            }
            return response.json() as Promise<TimeSheetEntry[]>;
        })
        .then(data => {
            return data;
        });
};
export const TimeSheets_Customer_NotInvoicedByConsultant = async (token: string, consultantid: string): Promise<TimeSheetEntry[] | undefined | null> => {
    if (!consultantid || !token) return null;

    return fetch(`api/TimeSheets/` + consultantid + "/UnInvoicedByConsultant", {
        method: "get",
        headers: {
            "Content-Type": "application/json",
            authorization: "bearer " + token,
        },
        mode: "cors",
        cache: "default",
    })
        .then(response => {
            if (response.status === 403) {
                return null;
            }
            else if (response.status === 404 || response.status === 204) {
                return undefined;
            }
            return response.json() as Promise<TimeSheetEntry[]>;
        })
        .then(data => {
            return data;
        });
};
